import ButtonDisplayField from '@admin/components/mjson_designer/components/buttondisplayfield'
import ResponsiveField from '@admin/components/mjson_designer/components/responsivefield'
import ButtonsField from '@admin/components/mjson_designer/components/buttonsfield'
import WebRange from '@admin/components/mjson_designer/components/webrange'
import { normalizeConfig } from '../../../utils'
import Form from '@admin/components/form'
import * as styles from '../styles'
import settings from '../settings'
import PropTypes from 'prop-types'
import React from 'react'

const Display = (props) => <ResponsiveField { ...props } component={ ButtonDisplayField } />
const Range = (props) => <ResponsiveField { ...props } component={ WebRange } />

class EditButtonsBlock extends React.PureComponent {

  static propTypes = {
    device: PropTypes.string,
    entity: PropTypes.object,
    parent: PropTypes.object,
    theme: PropTypes.object,
    type: PropTypes.string,
    website: PropTypes.object,
    onChange: PropTypes.func,
    onDone: PropTypes.func
  }

  formRef = React.createRef()

  _handleCancel = this._handleCancel.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  constructor(props) {
    super(props)
    const { entity } = props
    this.state = {
      default: entity,
      config: entity
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this._handleChange()
    }
  }

  _getForm() {
    const { device, entity, parent, theme, type, website } = this.props
    const { config } = this.state
    return {
      ref: this.formRef,
      onChange: this._handleUpdate,
      onSuccess: this._handleDone,
      showHeader: false,
      buttons: [
        { label: 't(Cancel)', color: 'blue', basic: true, handler: this._handleCancel },
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      tabs: [
        {
          label: 't(Content)',
          sections: [
            {
              fields: [
                { label: 't(Buttons)', name: 'content.buttons', device, theme, website, type: ButtonsField, defaultValue: [
                  { content: { button: { text: 'Button 1' } }, styles: { button: { preset: 'primary_button' }, margin: '0 10px 0 10px' } },
                  { content: { button: { text: 'Button 2' } }, styles: { button: { preset: 'secondary_button' }, margin: '0 10px 0 10px' } }
                ], value: config.content.buttons }
              ]
            }
          ]
        },
        {
          label: 't(Styles)',
          sections: [
            {
              label: 't(Buttons)',
              collapsing: true,
              collapsed: true,
              fields: [
                { label: 't(Display)', name: 'styles.display', collapsing: true, collapsed: true, type: Display, device, theme, defaultValue: {
                  display: 'inline'
                }, value: config.styles.display },
                { label: 't(Button Gap)', name: 'styles.gap', device, collapsing: true, collapsed: true, type: Range, units: [
                  { name: 'px', min: 0, max: 25, step: 1 }
                ], nullValues: ['none','0px'], defaultValue: 'none', value: config.styles.gap }
              ]
            },
            ...styles.getIsFlexChild(parent) ? [
              styles.FlexChildSection(config, device, theme, website, type)
            ] : [],
            styles.BackgroundSection(config, device, theme, website, type),
            styles.BoxShadowSection(config, device, theme, website, type),
            styles.BorderSection(config, device, theme, website, type),
            styles.SizingSection(config, device, theme, website, type, true, true),
            styles.SpacingSection(config, device, theme, website, type),
            styles.TransformSection(config, device, theme, website, type),
            styles.AnimationSection(config, device, theme, website, type),
            styles.FiltersSection(config, device, theme, website, type),
            styles.OverflowSection(config, device, theme, website, type),
            styles.VisibilitySection(config, device, theme, website, type)
          ]
        },
        {
          label: 't(Settings)',
          sections: settings(config, type, entity)
        }
      ]
    }
  }

  _getNormalized() {
    const { entity } = this.props
    const { config } = this.state
    return normalizeConfig({
      ...entity,
      meta: config.meta,
      settings: config.settings,
      styles: config.styles,
      content: config.content
    })
  }

  _handleCancel() {
    this.props.onDone(this.state.default)
  }

  _handleChange() {
    const config = this._getNormalized()
    this.props.onChange(config)
  }

  _handleDone() {
    const config = this._getNormalized()
    this.props.onDone(config)
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleUpdate(config) {
    this.setState({
      config: {
        ...this.state.config,
        ...config
      }
    })
  }

}

export default EditButtonsBlock
